var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16948_2782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3872 0.0368652H3.61281C1.61751 0.0368652 0 1.65438 0 3.64968V12.3503C0 14.3456 1.61751 15.9631 3.61281 15.9631H12.3872C14.3825 15.9631 16 14.3456 16 12.3503V3.64968C16 1.65438 14.3825 0.0368652 12.3872 0.0368652Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1168 4.67285H11.2456L8.77965 7.4916L11.6806 11.3269H9.40902L7.62996 9.00098L5.59402 11.3269H4.46465L7.10215 8.31223L4.31934 4.67285H6.6484L8.25652 6.7991L10.1168 4.67285ZM9.72059 10.6513H10.3462L6.30871 5.31316H5.63746L9.72059 10.6513Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16948_2782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.9262,
    fill: "white",
    transform: "translate(0 0.0368652)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.3f49e119b74eb0be3ff7c2b3f0ddc69f.svg";
export { ForwardRef as ReactComponent };